











import { mapMutations, mapState } from "vuex";
import VInstrumentCard from "@/components/VInstrumentCard.vue";
import Vue from "vue";
import { Instrument } from "@/util/commonTypes";

export default Vue.extend({
  name: "MultipleResults",
  components: { VInstrumentCard },
  props: {
    showArchived: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    select(instrument: Instrument): void {
      this.setCurrentInstrument(instrument);
    },
    ...mapMutations(["setCurrentInstrument", "clearCurrentInstrument"]),
  },
  computed: {
    ...mapState(["searchResults"]),
  },
});
